export default "__VITE_ASSET__DMqjpLN___"